module.exports = __webpack_public_path__ + "img/camera-view-front.d6427297.png";